import React from "react";
import { makeStyles } from "@material-ui/core";
import Whyweexist from "../../../assets/Images/Whyweexist.mp4"; 


const customStyles = makeStyles({
  root: {
    padding: "150px 0px",
    borderRadius: "24px",
    boxShadow: "0 0 40px rgba(0, 0, 0, 0.10)", // soft black glow

  },
  videoWrapper: {
    position: "relative",
    overflow: "hidden",
    zIndex: 0,
    borderRadius:"10px",
    marginTop:"-80px",
    marginBottom:"-30px"



  },
  videoBG: {
    width: "80%",
    height: "80%",
    objectFit: "cover", // Ensures full cover on all screens
   marginLeft:"120px",
  },
});


const Work = () => {
  const classes = customStyles();

  return (
    <div className={classes.root}>
    <div className={classes.videoWrapper}>
        <video
          autoPlay
          muted
          playsInline
          loop
          className={classes.videoBG}
          src={Whyweexist}
        />
        </div>
    </div>
  );
};

export default Work;